import { IApplicationState } from '../../types/redux';

const defaultState = {
  isViewed: false,
};

export function halfScreenBannerReducer(state: IApplicationState['halfScreenBanner'] = defaultState) {
  return state;
}
